
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibitions/brochures",
      function () {
        return require("private-next-pages/exhibitions/brochures.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibitions/brochures"])
      });
    }
  